import React from "react";
import { DragSource } from "react-dnd";
import styled from "styled-components";

const source = {
  beginDrag(props, monitor) {
    return {
      type: props.type,
      props: { values: props.defaultProps.values },
      children: [],
      style: {},
      childOf: "Content"
    };
  }
};

const ContentItem = ({ type, component, connectDragSource, defaultProps }) =>
  connectDragSource(
    <div style={{ width: 140, height: 140 }}>
      <DivItem>
        {React.createElement(defaultProps.layout, defaultProps)}
      </DivItem>
    </div>
  );

const DivItem = styled.div`
  display: flex;
  flex: 1,
  padding:10px;
  margin:10px;
  height: 120px;
  width:120px;
`;

export default DragSource("Content", source, (connect, monitor) => ({
  connectDragSource: connect.dragSource()
}))(ContentItem);



// WEBPACK FOOTER //
// ./src/editor/layout/catalog/ContentItem.js